var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightning = function SvgLightning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2173 1.28219C14.5337 1.37796 14.75 1.6695 14.75 2V9.25H19C19.2766 9.25 19.5307 9.40224 19.6613 9.64611C19.7918 9.88998 19.7775 10.1859 19.624 10.416L11.624 22.416C11.4407 22.691 11.099 22.8136 10.7827 22.7178C10.4663 22.6221 10.25 22.3305 10.25 22V14.75H6C5.7234 14.75 5.46926 14.5978 5.33875 14.3539C5.20823 14.11 5.22254 13.8141 5.37596 13.584L13.376 1.58398C13.5593 1.30899 13.901 1.18641 14.2173 1.28219ZM7.40139 13.25H11C11.4142 13.25 11.75 13.5858 11.75 14V19.5229L17.5986 10.75H14C13.5858 10.75 13.25 10.4142 13.25 10V4.47709L7.40139 13.25Z"
  })));
};
export default SvgLightning;